import { useEffect } from 'react'
import OktaAuth from '@okta/okta-auth-js'
import { routes } from 'config'

import { oidcImpersonateGatewayConfig } from 'config/'

const GatewayCallback = () => {
  useEffect(() => {
    const authClient = new OktaAuth(oidcImpersonateGatewayConfig)
    authClient.token.parseFromUrl().then((idToken: any) => {
      const redirectUrl =
        process.env.REACT_APP_DEFAULT_REDIRECTION + '/dashboard'
      document.location.href = redirectUrl
    })
  })

  return null
}

export default GatewayCallback
